import api from "../api/axios";
import ENDPOINTS from "../api/endpoints";

const SESSION_EXPIRED_MESSAGE =
  "Your session expired. You were logged out. If you want to continue, please log in again.";

const decodeJwtPayload = (token) => {
  if (!token) return null;

  try {
    const parts = token.split(".");

    if (parts.length !== 3) return null;

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "="
    );

    return JSON.parse(window.atob(padded));
  } catch {
    return null;
  }
};

export const register = async (payload) => {
  const response = await api.post(ENDPOINTS.AUTH.REGISTER, payload);
  return response.data;
};

export const login = async (payload) => {
  const response = await api.post(ENDPOINTS.AUTH.LOGIN, payload);
  return response.data;
};

export const verifyEmail = async (token) => {
  const response = await api.get(ENDPOINTS.AUTH.VERIFY_EMAIL, {
    params: { token },
  });
  return response.data;
};

export const resendVerification = async (email) => {
  const response = await api.post(ENDPOINTS.AUTH.RESEND_VERIFICATION, null, {
    params: { email },
  });
  return response.data;
};

export const forgotPassword = async (payload) => {
  const response = await api.post(ENDPOINTS.AUTH.FORGOT_PASSWORD, payload);
  return response.data;
};

export const resetPassword = async (payload) => {
  const response = await api.post(ENDPOINTS.AUTH.RESET_PASSWORD, payload);
  return response.data;
};

export const persistLogin = (data) => {
  const token = data?.token || "";
  const role = data?.role || "";
  const user = data?.user || null;

  if (token) {
    localStorage.setItem("token", token);
  }

  if (role) {
    localStorage.setItem("role", role);
  }

  if (user) {
    localStorage.setItem("user", JSON.stringify(user));
  }
};

export const clearAuth = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("role");
  localStorage.removeItem("user");
};

export const getStoredToken = () => localStorage.getItem("token");
export const getStoredRole = () => localStorage.getItem("role");

export const getStoredUser = () => {
  const raw = localStorage.getItem("user");
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const isTokenExpired = (token) => {
  if (!token) return true;

  const payload = decodeJwtPayload(token);

  if (!payload?.exp) return false;

  const nowInSeconds = Math.floor(Date.now() / 1000);
  return payload.exp <= nowInSeconds;
};

export const hasValidSession = () => {
  const token = getStoredToken();

  if (!token) return false;

  return !isTokenExpired(token);
};

export const markSessionExpired = () => {
  sessionStorage.setItem("sessionExpiredMessage", SESSION_EXPIRED_MESSAGE);
};

export const getSessionExpiredMessage = () =>
  sessionStorage.getItem("sessionExpiredMessage") || "";

export const clearSessionExpiredMessage = () => {
  sessionStorage.removeItem("sessionExpiredMessage");
};

const authService = {
  register,
  login,
  verifyEmail,
  resendVerification,
  forgotPassword,
  resetPassword,
  persistLogin,
  clearAuth,
  getStoredToken,
  getStoredRole,
  getStoredUser,
  isTokenExpired,
  hasValidSession,
  markSessionExpired,
  getSessionExpiredMessage,
  clearSessionExpiredMessage,
};

export default authService;